import React, { useRef, useState } from 'react'
import { assert } from '~/lib/customAssert'
type Props<T> = {
  items: T[]
  renderItem(
    props: {
      item: T
      isDragging: boolean
      dragProps: React.HTMLAttributes<unknown>
    },
    index: number,
  ): React.ReactNode
  onReorder(reorderedItems: T[]): void
  disabled?: boolean
}

export const Reorderable = <T,>(props: Props<T>) => {
  const [draggingItem, setDraggingItem] = useState<number | null>(null)
  const targetItemRef = useRef<number | null>(null)

  const reorder = () => {
    if (draggingItem !== null && targetItemRef.current !== null && draggingItem !== targetItemRef.current) {
      const newItems = [...props.items]
      const [target] = newItems.splice(draggingItem, 1)
      assert(target) // 基本ないはず
      newItems.splice(targetItemRef.current, 0, target)
      props.onReorder(newItems)
    }

    setDraggingItem(null)
    targetItemRef.current = null
  }

  return (
    <>
      {props.items.map((item, index) =>
        props.renderItem(
          {
            item,
            isDragging: index === draggingItem,
            dragProps: {
              draggable: !props.disabled,
              onDragStart: () => setDraggingItem(index),
              onDragOver: (e) => {
                e.preventDefault()
                e.dataTransfer.effectAllowed = 'move'
              },
              onDragEnter: () => (targetItemRef.current = index),
              onDragEnd: reorder,
            },
          },
          index,
        ),
      )}
    </>
  )
}
